<template>
  <base-picture-avatar
    :src="src"
    :src-default="require(`@/assets/company.svg`)"
    :width="width"
    :height="height" v-bind="$attrs"
  ></base-picture-avatar>
</template>

<script>
export default {
  name: 'BasePictureCompanyAvatar',

  inheritAttrs: false,

  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 40,
    },
    height: {
      type: [String, Number],
      default: 40,
    },
  },
};
</script>
